module.exports = __webpack_public_path__ + "static/media/expandRowRightArrowIcon.2808e505.svg";